import React, { useState } from 'react';
import styled from 'styled-components';
import { neutral } from '../../style/colors';
import { IKommune } from '../../Interfaces/IKommune';

const KommuneSelect = React.memo((props: KommuneSelectPropTypes) => {
  const { kommuner } = props;
  const [selectedKommune, setSelectedKommune] = useState('');

  const renderOptions = () => {
    return kommuner
      .sort((a, b) => {
        return a.navn
          .toLowerCase()
          .replace('aa', 'å')
          .replace('æ', 'z') >
          b.navn
            .toLowerCase()
            .replace('aa', 'å')
            .replace('æ', 'z')
          ? 1
          : -1;
      })
      .map(kommune => {
        return (
          <option key={kommune.kode} value={kommune.kode}>
            {kommune.navn}
          </option>
        );
      });
  };
  return (
    <Wrapper
      value={selectedKommune}
      onChange={e => setSelectedKommune(e.target.value)}
    >
      {renderOptions()}
    </Wrapper>
  );
});

const Wrapper = styled.select.attrs({
  name: 'kommuneSelect',
})`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  height: 50px;
  padding: 4px 4px 4px 17px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  background-color: #fff;
  border: ${neutral[200]} solid 1px;
  color: ${neutral[600]};
  background-image: url('data:image/svg+xml,%0A%3Csvg width="10px" height="6px" viewBox="0 0 10 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"%3E%3Cg id="Screens" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"%3E%3Cg id="Splash-screen---Velkommen" transform="translate(-945.000000, -599.000000)" stroke="%23ABBBC7" stroke-width="1.5"%3E%3Cg id="Group-4" transform="translate(666.500000, 343.648886)"%3E%3Cpolyline id="Stroke-55" transform="translate(283.502670, 258.501335) rotate(-270.000000) translate(-283.502670, -258.501335) " points="281.501335 262.504006 285.504006 258.501335 281.501335 254.498665"%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E');
  background-repeat: no-repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
  :focus {
    border: 1px solid #6a72a6;
    outline: none;
  }
  :hover {
    border: 1px solid #6a72a6;
  }
`;

interface KommuneSelectPropTypes {
  kommuner: Array<IKommune>;
}

export default KommuneSelect;
